import { PropertyType } from '../../common';

const mapErrors = (errors: PropertyType) => Object.keys(errors).map((k) => errors[k][0]);

export const onRequest = async (
	submitFunc: () => Promise<PropertyType | void>,
	global?: boolean
): Promise<PropertyType | void> => {
	let message;

	try {
		message = await submitFunc();
	} catch (error: any) {
		const errors = error?.response?.data.errors;
		message = errors && { errors: mapErrors(errors), success: '' };
		if (global)
			message = errors && {
				globalErrors: mapErrors(errors),
				globalSuccess: '',
			};
	}

	return message || {};
};
